import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    width: 100%;
`;

export const DataBlocksWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
`;

export const DataBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DataLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowMedium};
    margin-bottom: 0;
  `}
`;

export const DataValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowDark};
    margin-top: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ButtonWrapper = styled.div`
  width: 100%;
`;
